import VideoAttachment from './VideoAttachment';

export default VideoAttachment;
